<div class="page-layout carded fullwidth inner-scroll">
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center" id="reporte" #reporte>
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <div class="content-card">
            <div fxLayoutAlign="center center" style="padding-top: 10px;">
                <img src='{{rutaimagen}}' alt="Logo-Norm35" class="centradoIMG " style="width: 520px; height: 130px;">
            </div>
            <div class="content-card mainDiv mainDiv">
                <div fxLayoutAlign="center center" style="padding-top: 10px;">
                    <h1 style="font-weight: bold">{{nombreCT}}</h1>
                </div>
                <div fxLayoutAlign="center center" style="padding-top: 7px;">
                    <h2>{{'PDF.TITLE' | translate}}</h2>
                </div>


                <div fxLayoutAlign="start center" style="padding-top: 10px;">
                    <h2>{{'PDF.IND' | translate}}</h2>
                </div>
                <ul>
                    <h3><button mat-button (click)="indice2('obj');">{{'PDF.MAIN1' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3><button mat-button (click)="indice2('alcance');">{{'PDF.MAIN2' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3><button mat-button (click)="indice2('evidencia');">{{'PDF.MAIN3' | translate}}</button></h3>
                </ul>

                <ul>
                    <!-- <button mat-button (click)="indice2('incisoA');"></button>-->
                    <h3 class="indice"><button mat-button (click)="indice2('incisoA');">{{'PDF.INCISOA' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3 class="indice"><button mat-button (click)="indice2('incisoB');">{{'PDF.INCISOB' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3 class="indice"><button mat-button (click)="indice2('incisoC');">{{'PDF.INCISOC' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3 class="indice"><button mat-button (click)="indice2('incisoD');">{{'PDF.INCISOD' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3 class="indice"><button mat-button (click)="indice2('incisoE');">{{'PDF.INCISOE' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3 class="indice"><button mat-button (click)="indice2('incisoF');">{{'PDF.INCISOF' | translate}}</button></h3>
                </ul>
                <ul>
                    <h3 class="indice"><button mat-button (click)="indice2('incisoG');">{{'PDF.INCISOG' | translate}}</button></h3>
                </ul>

                <div style="padding-top: 6px;">
                    <div>
                        <ul>
                            <h2 id="obj">{{'PDF.MAIN1' | translate}}.</h2>
                            <p>{{'PDF.PARRAFO1' | translate}}</p>
                        </ul>
                        <ul>
                            <h2 id="alcance">{{'PDF.MAIN2' | translate}}.</h2>
                            <p>{{'PDF.PARRAFO1' | translate}}</p>
                        </ul>
                        <ul>
                            <h2 id="evidencia">{{'PDF.MAIN3' | translate}}.</h2>
                            <ng-container *ngIf="arrayTodoList">
                                <div *ngFor="let tareas of arrayTodoList; let k = index;" style="padding-top:7px;">

                                    <ul id="{{IncisosUrl[k]}}">{{Incisos[k]}}</ul>
                                    <br>
                                    <ul>{{DescripcionIncisos[k]}}</ul><br>
                                    <ul *ngIf="titleCantidad[k]"> {{titleCantidad[k]}}</ul>

                                    <br>
                                    <ng-container *ngIf="tipo35_tmp != '2'">
                                        <table class="blueTable">
                                            <thead>
                                                <tr>
                                                    <th style="width: 70%;">{{'PDF.SECCION1' | translate}}</th>
                                                    <th style="width: 30%;">{{'PDF.SECCION2' | translate}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let tareas of arrayTodoList[k].tareas">
                                                    <td style="padding-left: 2px; padding-right: 2px;" style="width: 70%;">{{tareas.descripcion}}</td>
                                                    <td style="width: 30%;">
                                                        <mat-list>
                                                            <mat-list-item *ngFor="let arch_CT of tareas.archivos; let i = index; last as last">
                                                                <a mat-line class="linkArchivo" target="_blank" href="{{pathTmpFiles}}{{arch_CT.rutaArchivo}}" style="word-break: break-all;">{{arch_CT.acortador}}</a>
                                                                <!--<button mat-icon-button (click)="deletePrimaryFile(i,idSeccionTmp,primary._id,arch_CT._id,primary.archivos,k,primary.estatus)"><mat-icon class="mat-24">delete</mat-icon></button>-->
                                                                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                                                            </mat-list-item>
                                                        </mat-list>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </ng-container>

                                    <ng-container *ngIf="tipo35_tmp == '2'">
                                        <table class="blueTable">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50%;">{{'PDF.SECCION1' | translate}}</th>
                                                    <th style="width: 25%;">{{'PDF.SECCION2' | translate}}</th>
                                                    <th style="width: 25%;">{{'PDF.SECCION3' | translate}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let tareas of arrayTodoList[k].tareas">
                                                    <td style="padding-left: 2px; padding-right: 2px;" style="width: 50%;">{{tareas.descripcion}}</td>
                                                    <td style="padding-left: 2px; padding-right: 2px;" style="width: 25%;">{{tareas.observaciones}}</td>
                                                    <td style="width: 25%;">
                                                        <mat-list>
                                                            <mat-list-item *ngFor="let arch_CT of tareas.archivos; let i = index; last as last">
                                                                <a mat-line class="linkArchivo" target="_blank" href="{{pathTmpFiles}}{{arch_CT.rutaArchivo}}" style="word-break: break-all;">{{arch_CT.acortador}}</a>
                                                                <!--<button mat-icon-button (click)="deletePrimaryFile(i,idSeccionTmp,primary._id,arch_CT._id,primary.archivos,k,primary.estatus)"><mat-icon class="mat-24">delete</mat-icon></button>-->
                                                                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                                                            </mat-list-item>
                                                        </mat-list>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </ng-container>

                                    <br>
                                </div>
                                <div class="mt-20" fxLayout="row" fxLayoutAlign="center stretch" id="destinoPrueba">
                                    <button mat-raised-button class="primary btnAncho" (click)="reporteCT();">
                                        {{'PDF.BTN' | translate}}
                                    </button>
                                </div>
                            </ng-container>
                        </ul>

                    </div>
                </div>

                <hr>
            </div>
            <!-- Sección de consultar tareas-->
            <!--<div *ngIf=" dataId.id==d atita.position ">-->
        </div>
        <!-- / CONTENT -->
    </div>
</div>
<!-- / CENTER -->